import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "Services/Common/errorApiHandleUtils";
import { checkFilter } from "Services/Common/filterUtils";
import { doctorService } from "Services/Axios/doctorService";

export const getDoctor = createAsyncThunk(
    'doctor/getDoctor',
    async (filters, { rejectWithValue }) => {
        try {
            let filter = checkFilter(filters);
            const response = await doctorService.getDoctor(filter);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const submitDoctor = createAsyncThunk(
    'doctor/submitDoctor',
    async (data, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('name', data.name);
            formData.append('description', data.description);
            data.profile_picture && formData.append('profile_picture', data.profile_picture);

            let response;
            if (data.id) {
                response = await doctorService.updateDoctor(data.id, formData);
            } else {
                response = await doctorService.createDoctor(formData);
            }
            data.successCallback && data.successCallback();
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const deleteDoctor = createAsyncThunk(
    'doctor/deleteDoctor',
    async (id, { rejectWithValue }) => {
        try {
            const response = await doctorService.deleteDoctor(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);